<template>
  <section class="basket-form" id="checkout">

    <v-container v-if="isCheckingOut" key="2">
      <v-form @submit.prevent="submit">

        <basket-form-postcards class="mt-8" :form="form"/>
        <!--<divider class="mt-10"/>-->

        <basket-form-payment class="mt-14" :form="form" :isCakeInBasket="isCakeInBasket"/>

        <template v-if="isPaymentSystemSpecified">
          <basket-form-destinations class="mt-14" :form="form" @paymentSystemError="onPaymentSystemError"/>
        </template>

        <template v-if="destination">
          <basket-form-delivery-types v-if="withDeliveryTypes"
                                      @express-delivery-change="handleExpressDeliveryChange"
                                      class="mt-14"
                                      :is-express-delivery-unavailable="isExpressDeliveryUnavailable"
                                      :is-cake-in-basket="isCakeInBasket"
                                      :form="form"/>

          <basket-form-delivery-courier v-if="isDeliveryTypeCourier"
                                        class="mt-14"
                                        :form="form"/>
          <basket-form-delivery-self v-else-if="isDeliveryTypeSelf" class="mt-14" :form="form" :is-cake-in-basket="isCakeInBasket"/>

        </template>

        <template v-if="isDeliverySpecified">
          <basket-form-delivery-date v-if="withDeliveryTypes && form.deliveryTypeId !== 3" class="mt-14"
                                     :form="form"/>
          <basket-form-contacts class="mt-14" :form="form "/>
          <basket-form-comments class="mt-14" :form="form "/>
          <basket-form-discount-card class="mt-14" :form="form"
                                     @onSuccessfulCardCheck="onSuccessfulCardCheck"
                                     @onUnsuccessfulCardCheck="onUnsuccessfulCardCheck"
                                     @onCancel="onDiscountCardCancel"/>

          <!--		  					<basket-form-coupon class="mt-14" :form="form"/>-->

          <divider class="mt-14"/>

          <basket-form-cost class="mt-14" :form="form"/>

          <basket-form-legal-entity-details v-if="isPaymentLegalEntitySpecified" class="mt-14" :form="form" :fields="legalEntityDetailsFields"/>

<!--          <basket-form-subscription class="mt-14" :form="form"/>-->
          <basket-form-agreement class="mt-14" :form="form"/>
          <btn-primary type="submit"
                       class="mt-8 d-block large mx-auto"
                       :disabled="!!validationError"
                       :loading="loading"
                       label="Продолжить"/>

          <p v-if="validationError"
             class="text-center mt-8">{{ validationError }}</p>

        </template>
      </v-form>
    </v-container>
    <v-container v-else key="2" class="text-center">
      <btn-primary :loading="loading" large @click="onCheckout">Оформить заказ</btn-primary>
    </v-container>

    <free-delivery-bar :form="form"/>

    <basket-payment-system-error-dialog :form="form"
                                        :isShown="isPaymentSystemErrorDialog"
                                        :destinationId="errorDestinationId"
                                        @close="isPaymentSystemErrorDialog = false;" />

    <v-dialog v-model="isErrorDialog" width="500">
      <v-card>
        <v-card-title class="justify-center">
          {{ this.isErrorDeliveryTime ? 'Выберите другую дату' : 'Проверьте форму' }}
        </v-card-title>

        <v-card-text class="justify-center text-center size-sm-md">
          {{ error }}
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
              text
              @click="error = null; isErrorDialog = null;">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isNotificationDialogShown" width="500">
      <v-card>
        <v-card-text class="size-sm-md py-5 px-6">
          <div v-html="notificationText"></div>
          <div v-if="notificationProducts && notificationProducts.length" class="basket-form__notification-form-products">
            <div v-for="(product) in notificationProducts" :key="product.ID">
              {{ capitalize(product.NAME.replace(/<[^>]*>/g, ' ')) }} {{ product.SUBNAME }}
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
              text
              @click="notificationText = null; isNotificationDialogShown = null;">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import Divider from "@/components/divider";
import BtnPrimary from '@/components/btn-primary';
import BtnText from '@/components/btn-text';
import BasketFormCoupon from './basket-form-coupon';
import BasketFormPostcards from './basket-form-postcards';
import BasketFormDestinations from './basket-form-destinations';
import BasketFormDeliveryTypes from './basket-form-delivery-types';
import BasketFormDeliveryCourier from './basket-form-delivery-courier';
import BasketFormDeliverySelf from './basket-form-delivery-self';
import BasketFormDeliveryDate from './basket-form-delivery-date';
import BasketFormContacts from './basket-form-contacts';
import BasketFormPayment from './basket-form-payment';
import BasketFormComments from './basket-form-comments';
import BasketFormCost from './basket-form-cost';
import BasketFormAgreement from './basket-form-agreement';
import {objectToArray, scrollTo} from '@/utils/utils';
import {geocodeYandex} from '@/utils/geo';
import {
  destinations,
  deliveryTypes,
  DELIVERY_TYPE_EXPRESS,
  DESTINATION_RUSSIA,
  DESTINATION_SPB,
  DESTINATION_MSK,
  DELIVERY_TYPE_SELF,
  DELIVERY_TYPE_COURIER_MSK,
  DELIVERY_TYPE_COURIER_SPB,
} from '@/store/delivery';
import vp from '@/mixins/vp';
import city from "@/mixins/city";

import Config from '@/config';
import BasketFormDiscountCard from "@/views/Basket/basket-form-discount-card.vue";
import BasketFormSubscription from "@/views/Basket/basket-form-subscription.vue";
import BasketNotification from "@/views/Basket/basket-notification.vue";
import config from "@/config";
import {capitalize} from "../../utils/string";
import BasketFormLegalEntityDetails from "@/views/Basket/basket-form-legal-entity-details.vue";
import {PAYMENT_SYSTEM_ID_LEGAL_ENTITY} from "@/store/payment";
import Vue from "vue";
import BasketPaymentSystemErrorDialog from "@/views/Basket/basket-payment-system-error-dialog.vue";
import FreeDeliveryBar from "@/views/Basket/free-delivery-bar.vue";
import metrika from "@/utils/metrika";

export default {
  name: "basket-form",
  components: {
    FreeDeliveryBar,
    BasketPaymentSystemErrorDialog,
    BasketFormLegalEntityDetails,
    BasketNotification,
    BasketFormSubscription,
    BasketFormDiscountCard,
    BtnPrimary,
    BtnText,
    Divider,
    BasketFormCoupon,
    BasketFormPostcards,
    BasketFormDestinations,
    BasketFormDeliveryTypes,
    BasketFormDeliveryCourier,
    BasketFormDeliverySelf,
    BasketFormDeliveryDate,
    BasketFormContacts,
    BasketFormPayment,
    BasketFormComments,
    BasketFormCost,
    BasketFormAgreement,
  },
  props: {
    items: {
      type: Array,
      required: true,
    }
  },
  mixins: [vp, city],
  data() {
    return {
      form: {
        destinationId: null,
        deliveryId: null,	// битрикс delivery.ID

        // искусственные установки для ФЕ
        deliveryTypeId: null,	// курьер, экспресс, самовывоз
        deliveryZoneId: null,	// зона доставки (курьер|экспресс)
        deliveryPlaceId: null,	// точка самовывоза
        deliveryCoords: null,	// точка на карте (в случае доставки курьером)
        deliveryCost: null,	// стоимость доставки (может быть null) - для сопоставления на БЕ

        paymentSystemId: null,

        DATE_DELIVERY: null,
        TIME: null,

        //COUNTRY: 'Россия',
        //ZIP: '',
        CITY: '',
        //STATE: '',
        STREET: '',
        BUILDING: '',
        ENTRANCE: '',
        FLOOR: '',
        APT: '',

        NAME: '',
        EMAIL: '',
        PHONE: '',

        COMMENTS: '',

        DISCOUNT_CARD: '',

        POSTCARD_ID: 0,
        POSTCARD_PRICE: 0,
        POSTCARD_TEXT: '',

        CARD_NUMBER: '',

        IS_SUBSCRIBE: 'N',

        discountBasket: null,
        couponDiscount: 0,
        hasAccepted: false,
      },
      isCardChecked: false,
      loading: false,
      isErrorDialog: false,
      isPaymentSystemErrorDialog: false,
      errorDestinationId: null,
      isSuccessDialog: false,
      error: null,
      isCheckingOut: true,
      isExpressDelivery: false,
      isCourierDeliveryAvailable: false,
      DELIVERY_HOUR_LIMIT: Config.DELIVERY_HOUR_LIMIT,
      isErrorDeliveryTime: false,

      isNotificationDialogShown: null,
      notificationText: null,
      notificationProducts: [],

      isMinWeightReached: null,

      CAKE_CATEGORY_CODE: 'torty',
    }
  },
  watch: {
    isCakeNotificationShown(isShown) {
      if (isShown) {
        this.notificationText = this.cakeNotificationText;
        this.notificationProducts = [];
        this.isNotificationDialogShown = true;
      }
    },
    isCakeRestaurantsNotificationShown(isShown) {
      if (isShown) {
        this.notificationText = this.cakeRestaurantsNotificationText;
        this.notificationProducts = [];
        this.isNotificationDialogShown = true;
      }
    },
    // discountBasket - это снимок цен, посчитанный бэкендом под конкретный состав корзины.
    // Если состав меняется (удалили/добавили товар, поменяли кол-во) после проверки купона,
    // снимок становится неактуальным - сбрасываем купон и просим проверить заново.
    itemsSignature(newSignature, oldSignature) {
      if (oldSignature === undefined) return;
      if (newSignature === oldSignature) return;
      if (!this.form.discountBasket) return;

      this.resetCoupon();

      this.notificationText = 'Состав корзины изменился. Пожалуйста, проверьте скидочную карту ещё раз.';
      this.notificationProducts = [];
      this.isNotificationDialogShown = true;
    },
  },
  computed: {
    // строковый "отпечаток" состава корзины (ID + кол-во), чтобы watch реагировал
    // только на реальные изменения состава, а не на пересоздание массива items
    itemsSignature() {
      return this.items
          .filter(item => !item.IS_TICKET) // билет добавляется автоматически - не считаем это изменением состава
          .map(item => `${item.ID}:${item.AMOUNT}`)
          .sort()
          .join('|');
    },
    sections() {
      return this.$store.state.common.sections;
    },
    cakeSectionId() {
      return this.sections.find(section => section.CODE === this.CAKE_CATEGORY_CODE)?.ID;
    },
    legalEntityDetailsFields() {
      return this.$store.state.page?.BasketController?.orderUriProps;
    },
    isUnavailableProductsExists() {
      return this.getUnavailableBasketItemsCount(this.$store.state.session?.basket) > 0;
    },
    isInactiveProductsExists() {
      let hasInactiveProducts = false;

      this.$store.state.session.basket?.forEach(basketItem => {
        if (basketItem.product?.ACTIVE === Config.INACTIVE_PRODUCT_VALUE) hasInactiveProducts = true;
      });

      return hasInactiveProducts;
    },
    validationError() {
      if (this.isCakeNotificationShown) return this.cakeErrorText;
      if (this.isUnavailableProductsExists || this.isInactiveProductsExists) return "Пожалуйста, удалите из корзины недоступные товары.";
      if (!this.form.destinationId) return "Пожалуйста, выберите пункт назначения.";
      if (this.closedPreorderItems.length) {
        return "Предзаказ на «" + this.closedPreorderItems.map(item => item.product.NAME.replace(/<br\s*\/?>/gi, ' ')).join("», «") + "» закрыт в выбранном регионе. Пожалуйста, удалите товар из корзины.";
      }
      if (this.overLimitPreorderItems.length) {
        return "Превышено максимальное количество по предзаказу на «" + this.overLimitPreorderItems.map(product => product.NAME.replace(/<br\s*\/?>/gi, ' ')).join("», «") + "». Пожалуйста, уменьшите количество в корзине.";
      }
      //if ( !this.form.delivery ) return "Пожалуйста, выберите пункт назначения.";
      if (this.isDeliveryTypeCourier) {
        if (!this.form.CITY) return "Пожалуйста, укажите город адреса доставки.";
        if (!this.form.STREET) return "Пожалуйста, укажите улицу адреса доставки.";
        if (this.withDeliveryTypes && this.form.deliveryTypeId !== 3) {
          if (!this.form.DATE_DELIVERY) return "Пожалуйста, выберите дату доставки.";
          if (!this.form.TIME) return "Пожалуйста, укажите временной интервал доставки.";
        }
      } else if (this.isDeliveryTypeSelf) {
        if (!this.form.STREET) return "Пожалуйста, выберите пункт самовывоза.";
        if (!this.form.deliveryPlaceId) return "Пожалуйста, выберите пункт самовывоза.";
        if (!this.form.DATE_DELIVERY) return "Пожалуйста, выберите дату получения.";
      }

      if (!this.form.NAME) return "Пожалуйста, укажите контактное имя получателя.";
      if (!this.form.EMAIL) return "Пожалуйста, укажите контактный емейл получателя.";
      if (!this.form.PHONE) return "Пожалуйста, укажите контактный телефон получателя.";
      if (this.form.DISCOUNT_CARD && !this.isCardChecked) return "Пожалуйста, нажмите Проверить в поле ввода номера скидочной карты.";
      if (!this.form.paymentSystemId) return "Пожалуйста, укажите вариант оплаты.";

      if (this.isPaymentLegalEntitySpecified) {
        const paymentLegalEntityErrors = [];

        this.legalEntityDetailsFields.forEach((field) => {
          if (field.REQUIED === 'Y' && !this.form[field.CODE]) paymentLegalEntityErrors.push("Пожалуйста, укажите " + field.NAME);
        });

        if (paymentLegalEntityErrors.length) return paymentLegalEntityErrors[0];
      }

      if (!this.form.hasAccepted) return "Пожалуйста, ознакомьтесь и примите наши Общие условия продажи.";
      return null;
    },
    // товары по предзаказу, предзаказ на которые закрыт в выбранном пункте назначения
    closedPreorderItems() {
      const destinationId = this.form.destinationId;
      if (destinationId !== DESTINATION_SPB && destinationId !== DESTINATION_MSK) return [];

      return this.items.filter(item => {
        const product = item.product;
        if (!product?.PREORDER_DELIVERY_FROM) return false;
        return destinationId === DESTINATION_SPB ? !!product.IS_PREORDER_CLOSED_SPB : !!product.IS_PREORDER_CLOSED_MSK;
      });
    },
    // товары по предзаказу, количество которых в корзине превышает лимит MAX_PREORDER_QUANTITY (суммируем по товару)
    overLimitPreorderItems() {
      const totals = {};
      this.items.forEach(item => {
        const product = item.product;
        if (!product?.PREORDER_DELIVERY_FROM || item.IS_TICKET) return;
        const entry = totals[product.ID] || (totals[product.ID] = {product, amount: 0});
        entry.amount += Number(item.AMOUNT) || 0;
      });
      return Object.values(totals).filter(({product, amount}) => {
        const max = Number(product.MAX_PREORDER_QUANTITY);
        return max > 0 && amount > max;
      }).map(({product}) => product);
    },
    isExpressDeliveryUnavailable() {
      // экспресс недоступен и при наличии в корзине товара по предзаказу (доставка не ранее даты предзаказа)
      return !!this.$store.getters.basketPreorderDeliveryFrom
          || this.items.filter(item => item.product.IS_EXPRESS_UNAVAILABLE)?.length > 0;
    },
    destination() {
      console.log('dest: ', destinations.find(el => el.id === this.form.destinationId), this.form.destinationId);
      return destinations.find(el => el.id === this.form.destinationId);
    },
    deliveryType() {
      return deliveryTypes.find(el => el.id === this.form.deliveryTypeId);
    },
    withDeliveryTypes() {
      return this.destination && this.destination.deliveryTypeIds?.length;
    },
    isDeliveryTypeCourier() {
      return (this.deliveryType && !this.isDeliveryTypeSelf) || !this.withDeliveryTypes;
    },
    isDeliveryTypeSelf() {
      return this.withDeliveryTypes && this.deliveryType?.isSelf;
    },
    isDeliverySpecified() {
      return this.destination &&
          ((this.isDeliveryTypeCourier && this.form.deliveryZoneId)
              || (this.isDeliveryTypeSelf && this.form.deliveryPlaceId)
              || !this.withDeliveryTypes);
    },
    isPaymentLegalEntitySpecified() {
      return this.form.paymentSystemId === PAYMENT_SYSTEM_ID_LEGAL_ENTITY;
    },
    isPaymentSystemSpecified() {
      return !!this.form.paymentSystemId;
    },
    cakeNotificationText() {
      return this.$store.state.page.BasketController?.settings?.CAKE_NOTIFICATION?.DETAIL_TEXT;
    },
    cakeRestaurantsNotificationText() {
      return this.$store.state.page.BasketController?.settings?.CAKE_RESTAURANT_NOTIFICATION?.DETAIL_TEXT;
    },
    cakeErrorText() {
      return this.$store.state.page.BasketController?.settings?.CAKE_NOTIFICATION?.PREVIEW_TEXT;
    },
    isCakeInBasket() {
      return this.items.filter(item => item.product.IBLOCK_SECTION_ID === this.cakeSectionId)?.length > 0;
    },
    isCakeOnlyPickupSpb() {
      return !!objectToArray(this.$store.state.page.BasketController?.settings)?.find(el => el.CODE === 'CAKE_ONLY_PICKUP_SPB');
    },
    isCakeOnlyPickupMsk() {
      return !!objectToArray(this.$store.state.page.BasketController?.settings)?.find(el => el.CODE === 'CAKE_ONLY_PICKUP_MSK');
    },
    isCakePickupOnlyRestaurantsSpb() {
      return !!objectToArray(this.$store.state.page.BasketController?.settings)?.find(el => el.CODE === 'CAKE_PICKUP_ONLY_RESTAURANTS_SPB');
    },
    isCakePickupOnlyRestaurantsMsk() {
      return !!objectToArray(this.$store.state.page.BasketController?.settings)?.find(el => el.CODE === 'CAKE_PICKUP_ONLY_RESTAURANTS_MSK');
    },
    isCakeNotificationShown() {
      if (this.isCakeInBasket && this.form.destinationId === DESTINATION_SPB && this.form.deliveryTypeId === DELIVERY_TYPE_SELF && !this.isCakeOnlyPickupSpb) return true;
      if (this.isCakeInBasket && this.form.destinationId === DESTINATION_MSK && this.form.deliveryTypeId === DELIVERY_TYPE_SELF && !this.isCakeOnlyPickupMsk) return true;
      if (this.isCakeInBasket && this.form.deliveryTypeId === DELIVERY_TYPE_EXPRESS) return true;
      if (this.isCakeInBasket && this.form.destinationId === DESTINATION_RUSSIA) return true;

      /*return this.isCakeInBasket && ((this.form.deliveryTypeId !== null && this.form.deliveryTypeId !== 1 && this.form.deliveryTypeId !== 4) ||
          this.form.destinationId === 3);*/
    },
    isCakeRestaurantsNotificationShown() {
      return !!(this.isCakeInBasket && ((this.form.destinationId === DESTINATION_SPB && this.isCakeOnlyPickupSpb && this.isCakePickupOnlyRestaurantsSpb) || (this.form.destinationId === DESTINATION_MSK && this.isCakeOnlyPickupMsk && this.isCakePickupOnlyRestaurantsMsk)));
    },
    cdekMinWeight() {
      return Number(this.$store.state.page.BasketController?.settings?.CDEK_NOTIFICATION?.VALUE);
    },
    cdekNotificationText() {
      return this.$store.state.page.BasketController?.settings?.CDEK_NOTIFICATION?.DETAIL_TEXT;
    },
    unavailableGoodsInDestinationNotificationText() {
      return this.$store.state.page.BasketController?.settings?.UNAVAILABLE_GOODS_IN_REGION_NOTIFICATION?.DETAIL_TEXT;
    },
  },
  methods: {
    capitalize,
    // Купон может быть уже применён на бэкенде (в сессии Bitrix), например если пользователь
    // проверил его и ушёл со страницы оформления заказа, не отменив его - см. SessionController.
    // Восстанавливаем состояние формы, чтобы не заставлять вводить купон заново только
    // для того, чтобы его отменить.
    // Вызывается только один раз при создании формы: сессия к этому моменту уже загружена (router.beforeEach).
    // Реагировать на дальнейшие изменения session.discountCoupon нельзя: store после проверки карты не обновляется,
    // и при смене состава корзины устаревшее null -> код восстановило бы купон сразу после его сброса (resetCoupon).
    restoreCouponFromSession() {
      const session = this.$store.state.session;
      if (!session?.discountCoupon || this.form.discountBasket) return;

      this.form.DISCOUNT_CARD = session.discountCoupon;
      this.form.couponDiscount = session.discountCouponPercent;
      this.form.discountBasket = session.discountBasket;
      this.isCardChecked = true;
    },
    onPaymentSystemError(destinationId) {
      this.errorDestinationId = destinationId;
      this.isPaymentSystemErrorDialog = true;
    },
    onSuccessfulCardCheck() {
      this.isCardChecked = true;
    },
    onUnsuccessfulCardCheck(errorMessage) {
      this.error = errorMessage;
      this.isErrorDialog = true;
    },
    onDiscountCardCancel() {
      this.isCardChecked = false;
    },
    // снимает купон и локально (form), и на бэкенде (сессия Bitrix), см. CancelCouponController
    // Номер карты тоже очищаем: непроверенный номер блокирует оформление заказа (см. errorMessage/submit)
    resetCoupon() {
      this.form.DISCOUNT_CARD = '';
      this.form.discountBasket = null;
      this.form.couponDiscount = 0;
      this.isCardChecked = false;

      this.$store.dispatch('post', {
        action: 'CancelCouponController',
      }).then((result) => {
        this.$store.commit('setSession', result);
      });
    },
    handleExpressDeliveryChange(isExpressDelivery) {
      this.isExpressDelivery = isExpressDelivery;
    },
    onCheckout() {
      this.isCheckingOut = true;
      setTimeout(() => {
        scrollTo('checkout', -120);
      }, 300);
    },
    checkDeliveryAvailability() {
      const now = new Date().toLocaleString("en-US", {timeZone: "Europe/Moscow"});
      const currentHour = new Date(now).getHours();
      if (currentHour >= 10 && currentHour < 16) {
        this.isExpressDelivery = true;
      } else {
        this.isExpressDelivery = false;
      }
    },
    checkCourierDeliveryAvailability() {
      const now = new Date().toLocaleString("en-US", {timeZone: "Europe/Moscow"});
      const currentHour = new Date(now).getHours();
      const currentMinute = new Date(now).getMinutes();
      const deliveryDate = this.form.DATE_DELIVERY;

      const today = new Date().toLocaleString("ru-RU", {timeZone: "Europe/Moscow"}).split(",")[0];
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      const tomorrowFormatted = tomorrow.toLocaleString("ru-RU", {timeZone: "Europe/Moscow"}).split(",")[0];

      // если текущее время больше 18:30 и выбранная дата доставки сегодня или завтра, то доставка недоступна
      if ((((currentHour === this.DELIVERY_HOUR_LIMIT && currentMinute >= this.DELIVERY_MINUTE_LIMIT) || currentHour >= (this.DELIVERY_HOUR_LIMIT + 1)) && currentHour <= 23) && (deliveryDate === today || deliveryDate === tomorrowFormatted)) {
        this.isCourierDeliveryAvailable = false;
        return;
      }

      this.isCourierDeliveryAvailable = true;
    },
    checkMinProductsWeight() {
      const productsWeight = this.items.reduce((weight, item) => {
        const productWeight = Number(item.product.WEIGHT);
        const productAmount = item.AMOUNT;

        if (!productWeight) console.warn('Для товара ' + item.product.NAME + ' не указан вес.');

        return weight + (productWeight * productAmount);
      }, 0);

      this.isMinWeightReached = productsWeight >= this.cdekMinWeight;
    },
    getBasketProductAvailability(product, section) {
      if (!product || !section) return true;
      if (this.destination.id === DESTINATION_SPB) {
        if (product.NO_SPB || Number(section.UF_NO_SPB)) return false;
      } else if (this.destination.id === DESTINATION_MSK) {
        if (product.NO_MSK || Number(section.UF_NO_MSK)) return false;
      } else if (this.destination.id === DESTINATION_RUSSIA) {
        if (product.NO_MSK || Number(section.UF_NO_MSK) || product.NO_SPB || Number(section.UF_NO_SPB) || product.NO_CDEK) return false;
      }
      return true;
    },
    checkBasketProductsAvailability() {
      if (!this.items?.length) return false;

      let hasUnavailableProducts = false;
      let unavailableItems = [];

      this.items.forEach((product) => {
        product = product.product;
        const section = this.sections?.find(section => section.ID === product.IBLOCK_SECTION_ID);
        const isProductAvailable = this.getBasketProductAvailability(product, section);

        if (!isProductAvailable) {
          hasUnavailableProducts = true;
          unavailableItems.push(product);
        }
      });

      return {
        hasUnavailableProducts,
        unavailableItems,
      }
    },
    submit() {
      const vals = [
        {
          re: /^.{3,}$/,
          cond: this.form.destination === 2 || this.form.destination === 3,
          value: this.form.PERSONAL_ZIP,
          msg: "Пожалуйста, укажите почтовый индекс"
        },
        {
          re: /^.{2,}$/,
          cond: this.form.destination === 3,
          value: this.form.PERSONAL_COUNTRY,
          msg: "Пожалуйста, укажите страну"
        },
        {
          re: /^.{2,}$/,
          cond: this.form.destination === 2 || this.form.destination === 3,
          value: this.form.PERSONAL_CITY,
          msg: "Пожалуйста, укажите город"
        },
        {
          re: /^.{2,}$/,
          value: this.form.PERSONAL_STREET,
          msg: "Пожалуйста, укажите адрес доставки"
        },
        {
          re: /^.+$/,
          value: this.form.PERSONAL_MAILBOX,
          msg: "Пожалуйста, укажите номер дома"
        },
        {
          re: /^.+$/,
          value: this.form.PERSONAL_NOTES,
          msg: "Пожалуйста, укажите номер квартиры/офиса"
        },
        {
          re: /^.{2,}$/,
          value: this.form.NAME,
          msg: "Пожалуйста, укажите Ваше полное имя"
        },
        {
          re: /^.+?@.+?\..+$/,
          value: this.form.EMAIL,
          msg: "Пожалуйста, укажите Ваш адрес электронной почты"
        },
        /*{
          re: /^\d{10,24}$/,
          value: this.form.PHONE.replace(/\D+/g, ""),
          msg: "Пожалуйста, укажите Ваш номер телефона"
        },
        {
          re: /^\d{10,24}$/,
          value: this.form.PHONE.replace(/\D+/g, ""),
          msg: "Пожалуйста, укажите Ваш номер телефона"
        }*/
      ];
      this.isErrorDeliveryTime = false;
      this.isErrorDialog = false;
      vals.forEach(el => {
        if (this.isErrorDialog) return;
        if (typeof el.cond !== "undefined" && !el.cond) return;
        if (!el.re.test(el.value)) {
          this.isErrorDialog = true;
          return (this.error = el.msg);
        }
      });
      if (this.isErrorDialog) return;

      this.loading = true;
      this.error = null;

      // Проверяем, все ли товары доступны в выбранном регионе
      const productsAvailability = this.checkBasketProductsAvailability();
      if (productsAvailability.hasUnavailableProducts) {
        this.notificationText = this.unavailableGoodsInDestinationNotificationText;
        this.notificationProducts = productsAvailability.unavailableItems;
        this.isNotificationDialogShown = true;
        this.loading = false;
        return;
      }

      // Если выбрана доставка в другой город проверяем минимальный вес заказа
      if (this.form.destinationId === DESTINATION_RUSSIA) {
        this.checkMinProductsWeight();

        if (!this.isMinWeightReached) {
          this.notificationText = this.cdekNotificationText;
          this.notificationProducts = [];
          this.isNotificationDialogShown = true;
          this.loading = false;
          return;
        }
      }
      //Проверяем, доступна ли сейчас Экспресс-доставка
      this.checkDeliveryAvailability();
      if (!this.isExpressDelivery && this.form.deliveryTypeId === DELIVERY_TYPE_EXPRESS) {
        this.isErrorDeliveryTime = true;
        this.error = "Экспресс-доставка сейчас недоступна. Пожалуйста, выберите другой вариант доставки.";
        this.isErrorDialog = true;
        this.loading = false;
        return;
      }
      //Проверяем, доступна ли доставка на выбранную дату
      this.checkCourierDeliveryAvailability();
      if (!this.isCourierDeliveryAvailable) {
        this.isErrorDeliveryTime = true;
        this.error = "На выбранную дату доставка недоступна. Пожалуйста, выберите другой день.";
        this.isErrorDialog = true;
        this.loading = false;
        return;
      }

      metrika.reachGoal('clickCreateOrder');

      this.$store.dispatch('post', {
        action: 'OrderController',
        params: this.form
      }).then((res) => {
        //this.isSuccessDialog = true;
        this.$router.push({name: 'order', params: {id: res?.page?.OrderController?.order?.ID}});
      }).catch((error) => {
        if (error.message === 'curier20' || error.message === 'unavailable-ordering-date') {
          this.isErrorDeliveryTime = true;
          this.error = "На выбранную дату доставка недоступна. Пожалуйста, выберите другой день.";
        } else if (error.message === 'preorder-delivery-date') {
          this.isErrorDeliveryTime = true;
          this.error = "В корзине есть товары по предзаказу, на выбранную дату доставка недоступна. Пожалуйста, выберите другой день.";
        } else if (error.message === 'preorder-closed') {
          this.isErrorDeliveryTime = true;
          this.error = "Предзаказ на некоторые товары в корзине закрыт. Пожалуйста, удалите их из корзины и повторите оформление.";
        } else if (error.message === 'preorder-max-quantity') {
          this.isErrorDeliveryTime = true;
          this.error = "Превышено максимальное количество некоторых товаров по предзаказу. Пожалуйста, уменьшите количество в корзине и повторите оформление.";
        } else if (error.message === 'preorder-destination') {
          this.isErrorDeliveryTime = true;
          this.error = "В корзине есть товары по предзаказу, поэтому доставка возможна только по Санкт-Петербургу и Москве.";
        } else if (error.message === 'payment') {
          this.isErrorDeliveryTime = true;
          this.error = "Оплата картой на сайте сейчас недоступна. Пожалуйста, выберите другой способ оплаты.";
        } else if (error.message === 'express') {
          this.isErrorDeliveryTime = true;
          this.error = "Экспресс-доставка сейчас недоступна. Пожалуйста, выберите другой вариант получения заказа.";
        } else if (error.message === 'other-city') {
          this.isErrorDeliveryTime = true;
          this.error = "Доставка в другой город сейчас недоступна.";
        } else if (error.message === 'cake-delivery') {
          this.isErrorDeliveryTime = true;
          this.error = "Заказ торта возможен только при самовывозе.";
        } else if (error.message === 'cake-with-ur-payment') {
          this.isErrorDeliveryTime = true;
          this.error = "Оплата для юр. лиц недоступна при заказе торта.";
        } else {
          if (error.message) {
            this.error = error.message;
          } else {
            this.error = "Что-то пошло не так. Пожалуйста, попробуйте, еще раз.";
          }
        }
        this.isErrorDialog = true;
      }).finally(() => {
        this.loading = false;
      });
    },
  },
  created() {
    this.restoreCouponFromSession();
  },
  mounted() {
    // добавляем в объект form поля для ввода реквизитов из админки
    this.legalEntityDetailsFields?.forEach(field => {
      Vue.set(this.form, field.CODE, "");
    });
  },
}
</script>

<style lang="scss">
.basket-form {
  padding-bottom: 128px;

  .btn-primary {
    background: rgba(255, 255, 255, .85) !important;
    //border: none;
  }

  .v-text-field {
    label.v-label {
      color: $gray;
    }

    input, .v-select__selection {
      color: $black-alpha-6;
    }
  }

  .v-textarea {
    textarea {
      color: $black-alpha-6;

      &::placeholder {
        color: $gray;
      }
    }
  }
}
</style>